@if (labels(); as pageLabels) {
  <main class="gs-page">
    <div class="biometrics-page">
      <div>
        <h1 data-cy="header-bio-terms">{{ pageLabels.header }}</h1>
      </div>
      <app-notification [pageName]="pageName"></app-notification>
      <section class="gs-outline">
        <div
          #fadeContainer
          class="fade-container gs-fade"
          data-cy="container-bio-terms-content"
          tabindex="0"
          role="region"
          aria-label="Terms and conditions"
          (scroll)="onscroll($event)"
        >
          <p>{{ pageLabels.termsText }}<span class="remove-fade"></span></p>
        </div>
      </section>
      <div class="button-container">
        <button
          mat-flat-button
          color="primary"
          class="gs-form-button-primary"
          data-cy="btn-accept-bio-terms"
          (click)="accept()"
        >
          {{ pageLabels.acceptButtonText }}
        </button>
        <button class="gs-button-link" data-cy="btn-cancel-bio-terms" (click)="cancel()">
          {{ pageLabels.cancelButtonText }}
        </button>
      </div>
      <div class="bio-terms-link-container">
        <a
          class="bio-terms-link"
          data-cy="link-terms-of-use"
          [attr.aria-label]="pageLabels.termsOfUseLink.ariaLabel"
          [href]="env.websiteBaseUrl + pageLabels.termsOfUseLink.url.url"
          target="_blank"
          rel="noopener"
          >{{ pageLabels.termsOfUseLink.displayText }}</a
        >
        <a
          class="bio-terms-link"
          data-cy="link-privacy-policy"
          [attr.aria-label]="pageLabels.privacyPolicyLink.ariaLabel"
          [href]="env.websiteBaseUrl + pageLabels.privacyPolicyLink.url.url"
          target="_blank"
          rel="noopener"
          >{{ pageLabels.privacyPolicyLink.displayText }}</a
        >
      </div>
    </div>
  </main>
}
